<template>
  <div class="operator-data_block">
    <p class="large_label">オペレーター情報</p>
    <TableBox :is-with-header="false" :table-contents="operatorData"/>
  </div>
</template>

<script>
  import TableBox from "@/components/molecules/box/TableBox";
  import moment from "moment";

  export default {
    name: "OperatorDataTable",

    components: {TableBox},

    props: {
      operator: {
        type: Object,
        required: true
      },
    },

    computed: {
      operatorData() {
        return {
          freeMoment: {
            dt: '作業可能期限',
            dd: !this.operator.freeMoment ? '' : moment.unix(this.operator.freeMoment.seconds).format('YYYY/MM/DD HH:mm'),
          },
          total: {
            dt: '総合',
            dd: this.operator && this.operator.scores ? this.operator.scores.total : '',
          },
          perfection: {
            dt: '作業の完成度',
            dd: this.operator && this.operator.scores ? this.operator.scores.perfection : '',
          },
          speed: {
            dt: '作業の速さ',
            dd: this.operator && this.operator.scores ? this.operator.scores.speed : '',
          },
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .operator-data_block {
    .large_label {
      margin: 4rem 0 2rem 0;
    }

    .table_box {
      margin: 2rem 0;
      width: 100%;
    }
  }
</style>